<div class="padding-20 ui-g" *ngIf="show.form" id="validationsCouponForm">

  <div class="flex-row ui-g-12">
    <div class="ui-g-6 flex-column">

      <div class="ui-g-12 info-div flex-row ">

        <div class="ui-g-1">
          <i class="fas fa-pencil-alt pointer" style="font-size: 2rem" (click)="onEdit(0)"></i>
        </div>
        <div class="ui-g-11 flex-column">
          <span class="bold-span">ID:<span data-testid="message_instance_id">{{id}}</span></span>
          <span class="bold-span">{{ actionType }} - {{ name }}</span>
          <span class="bold-span">{{ discountType }} - {{description}}</span>
        </div>

      </div>

      <div class="ui-g-12 info-div flex-row">
        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(1)"></i>
        </div>
        <div class="ui-g-11 flex-column">
          <span class="bold-span">{{ 'campaign.emission_period' | translate }}: {{startEmissionDate | date: dateFormat}}
            {{ 'campaign.to' | translate }} {{endEmissionDate | date: dateFormat}}</span>
          <span class="bold-span" *ngIf="!fruitionRolling">{{ 'campaign.fruition_period_from' | translate }}:
            {{startFruitionDate | date:
            dateFormat}} {{ 'campaign.to' | translate }} {{endFruitionDate | date: dateFormat}}</span>
          <span class="bold-span" *ngIf="fruitionRolling">{{'campaign.fruition_dates_variable'|translate}}</span>

        </div>


      </div>

      <div class="ui-g-12 info-div flex-row">
        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(2)"></i>
        </div>
        <div class="ui-g-11 flex-column">
          <div class="flex-row">
            <span>{{ 'campaign.generation_method' | translate }}: </span>
            <span class="bold answer">{{generationMethod}}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.target_customers' | translate }}: </span>
            <span class="bold answer">{{ targetLoyaltyClass }}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.generated_coupons' | translate }}: </span>
            <span class="bold answer">{{ actualGeneratedCoupon }}</span>
          </div>

        </div>
      </div>


      <div class="ui-g-12 info-div flex-row">

        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(3)"></i>
        </div>

        <div class="ui-g-11 flex-column">
          <div class="flex-row">
            <span>{{ 'campaign.emission_threshold' | translate }}:</span>
            <ng-container *ngIf="sogliaDiEmissione.value !== undefined && sogliaDiEmissione.value !== null">
              <span class="bold answer">{{ sogliaDiEmissione.type }} ({{ sogliaDiEmissione.value }})</span>
            </ng-container>
            <ng-container *ngIf="sogliaDiEmissione.value === undefined || sogliaDiEmissione.value === null">
              <span class="bold answer">{{ sogliaDiEmissione.type }}</span>
            </ng-container>
          </div>
          <!--
          <div class="flex-row">
            <span>Emissione ripetibile: </span>
            <ng-container
              *ngIf="emissioneRipetibile.value !== undefined && emissioneRipetibile.max !== undefined && (emissioneRipetibile.value !== 0 || emissioneRipetibile.max !== 0)">
              <span class="bold answer">{{ emissioneRipetibile.type }}
                <ng-container *ngIf="emissioneRipetibile.value !== 0 || emissioneRipetibile.max !== 0">
                  ({{ emissioneRipetibile.value }}, {{ emissioneRipetibile.max }})
                </ng-container>
              </span>
            </ng-container>
            <ng-container
              *ngIf="emissioneRipetibile.value === undefined || emissioneRipetibile.max === undefined || (emissioneRipetibile.value === 0 && emissioneRipetibile.max === 0)">
              <span class="bold answer">{{ emissioneRipetibile.type }}</span>
            </ng-container>
          </div>
         -->
          <div class="flex-row">
            <span>{{ 'campaign.emitters' | translate }}: </span>
            <span class="bold answer">{{ accumulatoriEmissione }}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.coupon_barcode' | translate }}: </span>
            <span class="bold answer">{{ barcodeCoupon }}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.activator_barcode' | translate }}: </span>
            <span class="bold answer">{{ barcodeAttivazione }}</span>
          </div>

        </div>
      </div>

      <div class="ui-g-12 info-div flex-row">

        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(4)"></i>
        </div>


        <div class="ui-g-11 flex-column">
          <div class="flex-row">
            <span>{{ 'campaign.fruition_threshold' | translate }}:</span>
            <ng-container *ngIf="sogliaDiFruizione.value !== undefined && sogliaDiFruizione.value !== null">
              <span class="bold answer">{{ sogliaDiFruizione.type }} ({{ sogliaDiFruizione.value }})</span>
            </ng-container>
            <ng-container *ngIf="sogliaDiFruizione.value === undefined || sogliaDiFruizione.value === null">
              <span class="bold answer">{{ sogliaDiFruizione.type }}</span>
            </ng-container>
          </div>


          <div class="flex-row">
            <span>{{ 'campaign.fruition_accumulators' | translate }}:</span>

            <span class="bold answer">{{ accumulatoriFruizione }}</span>
          </div>
        </div>


      </div>

      <div class="ui-g-12 info-div flex-row">
        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(5)"></i>
        </div>
        <div class="ui-g-11 flex-column">
          <div class="flex-row">
            <span>{{ 'campaign.emission_distribution_list' | translate }}:</span>
            <span class="bold answer">{{ listaDistribuzioneEmissione }}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.fruition_distribution_list' | translate }}:</span>
            <span class="bold answer">{{ listaDistribuzioneFruizione }}</span>
          </div>

        </div>
      </div>

      <div class="ui-g-12 info-div flex-row">

        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem;" (click)="onEdit(6)"></i>
        </div>
        <div class="ui-g-11 flex-column">
          <div class="flex-row">
            <span>{{ 'campaign.target_emission_articles' | translate }}:</span>
            <span class="bold answer">{{ targetArticoliEmissione }}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.target_fruition_articles' | translate }}:</span>
            <span class="bold answer">{{ targetArticoliFruizione }}</span>
          </div>

        </div>


      </div>

      <div class="ui-g-12 info-div flex-row">


        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(7)"></i>
        </div>

        <div class="ui-g-11 flex-column">
          <div class="flex-row">
            <span>{{ 'campaign.touchpoint_emission' | translate }}:</span>
            <span class="bold answer">{{ touchPointEmissione }}</span>
          </div>
          <div class="flex-row">
            <span>{{ 'campaign.touchpoint_fruition' | translate }}:</span>
            <span class="bold answer">{{ touchPointFruizione }}</span>
          </div>

        </div>

      </div>

      <div class="ui-g-12 info-div flex-row" *ngIf="summaryAccumulatorToMove.length > 0 || summaryAccumulatorToControl.length > 0 ||
        summaryAccumulatorToMoveFruition.length > 0 || summaryAccumulatorToControlFruition.length > 0">
        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(4)"></i>
        </div>

        <div class="ui-g-11 flex-column">

          <div *ngIf="summaryAccumulatorToMove.length > 0 || summaryAccumulatorToControl.length > 0">
            <span class="section-title">{{ 'campaign.emission' | translate }}</span>
            <div class="flex-row" *ngFor="let item of summaryAccumulatorToMove">
              <span>{{ 'campaign.acmdamuovere' | translate }}:</span>
              <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
            </div>

            <div class="flex-row" *ngFor="let item of summaryAccumulatorToControl">
              <span>{{ 'campaign.acmDacontrollare' | translate }}:</span>
              <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
            </div>
          </div>

          <div *ngIf="summaryAccumulatorToMoveFruition.length > 0 || summaryAccumulatorToControlFruition.length > 0">
            <span class="section-title">{{ 'campaign.fruition' | translate }}</span>
            <div class="flex-row" *ngFor="let item of summaryAccumulatorToMoveFruition">
              <span>{{ 'campaign.acmdamuovere' | translate }}:</span>
              <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
            </div>

            <div class="flex-row" *ngFor="let item of summaryAccumulatorToControlFruition">
              <span>{{ 'campaign.acmDacontrollare' | translate }}:</span>
              <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
            </div>
          </div>
        </div>
      </div>


    </div>



    <!-- colonna di destra -->
    <div class="ui-g-6 flex-column">

      <!--TODO tenst new touchpoint wizard -->

      <div class="ui-g-12 info-div flex-row">

        <div class="ui-g-1">
          <i class="pi pi-pencil pointer" style="font-size: 2rem" (click)="onEdit(7)"></i>
        </div>

        <div class="ui-g-11 flex-column">
          <!-- Touchpoint emissione:Attenzione  ON e OFF  -->
          <div *ngIf="touchPointEmission.length != 0" class="flex-colunmn">
            <h3>{{ 'campaign.wizard_emission' | translate }}</h3>


            <div *ngFor="let tp of touchPointEmission">
              <div *ngIf="(tp.flg_deployable == 'E' || tp.flg_deployable == '1')" class="touchPointContainer">

                <span>{{ tp.description }}</span>
                <div *ngIf="tp.certifier == 'Yes' && tp.wizardList" class="ui-g-12 touchpoint-row">


                  <div class="fa fa-search wizardSearchIcon circleIcon"
                    [ngClass]="{'disabled': isWizardEmissionDisabled}"
                    (click)="isWizardEmissionDisabled ? null : onClickSearchWizard('E', tp, i)">
                  </div>

                  <app-form-fields style="flex-grow: 1; margin-bottom:15px" #wizard_emission
                    data-testid="wizard_emission" [readOnly]="readOnly"
                    (fieldModelChange)="onChangeWizard('E','OFF',i,$event)" [showLabel]="false"
                    [(fieldModel)]="tp.wizardModel" [type]="'dropdown'" [options]="tp.wizardList" [optionLabel]="'name'"
                    [placeholder]="'Wizard'" [disabled]="isWizardEmissionDisabled">
                  </app-form-fields>

                </div>
              </div>
            </div>
          </div>
          <!-- Touchpoint emissione :guardare oFF e ON -->
          <div *ngIf="touchPointFruition.length != 0" class="flex-colunmn">
            <h3>{{ 'campaign.wizard_fruition' | translate }}</h3>


            <div *ngFor="let tp of touchPointFruition">
              <div *ngIf="(tp.flg_deployable == 'F' || tp.flg_deployable == '1')" class="touchPointContainer">
                <span>{{ tp.description }}</span>
                <div *ngIf="tp.certifier == 'Yes' && tp.wizardList" class="ui-g-12 touchpoint-row">


                  <div class="fa fa-search wizardSearchIcon circleIcon"
                    [ngClass]="{'disabled': isWizardFruitionDisabled}"
                    (click)="isWizardFruitionDisabled ? null : onClickSearchWizard('F', tp, i)">
                  </div>

                  <app-form-fields style="flex-grow: 1; margin-bottom:15px" #wizard_fruition
                    data-testid="wizard_fruition" [readOnly]="readOnly"
                    (fieldModelChange)="onChangeWizard('E','OFF',i,$event)" [showLabel]="false"
                    [(fieldModel)]="tp.wizardModel" [type]="'dropdown'" [options]="tp.wizardList" [optionLabel]="'name'"
                    [placeholder]="'Wizard'" [disabled]="isWizardFruitionDisabled">
                  </app-form-fields>

                </div>
              </div>
            </div>
          </div>

          <div *ngIf="wizardMessagge" class="alert alert-warning alert-dismissible fade show" role="alert">
            {{ 'campaign.wizardMissing' | translate }}
          </div>


          <div class="d-flex" style="justify-content: center;">
            <button data-testid="save_wizard" class="btn" style="margin-top: 0px;" (click)="onSaveWizard()"
              [disabled]="disablingSavingWizardState" [ngClass]="{'btn-disabled': disablingSavingWizardState == true }">
              <span>{{ 'campaign.save_wizard' | translate }}</span>

            </button>

          </div>


        </div>




      </div>


      <div class="ui-g-12">
        <br />
        <div *ngFor="let tp of certificationTouchpointList.certifiedTouchpoint; let i = index;">
          <span class="bold" style="padding-right: 5px;">
            {{ 'campaign.certification' | translate }} {{ tp.touchpointCode }} - {{ tp.touchpointDescription }}:
          </span>
          <span class="greenText">
            <i class="fa fa-check"></i>&nbsp;{{ 'campaign.certified' | translate }} ({{ tp.promoClass }})
          </span>
        </div>
        <br />
        <div *ngFor="let tp of certificationTouchpointList.notCertifiedTouchpoint; let i = index;">
          <span class="bold" style="padding-right: 5px;">
            {{ 'campaign.certification' | translate }} {{ tp.touchpointCode }} - {{ tp.touchpointDescription }}:
          </span>
          <span class="redText">
            <i class="fa fa-times"></i>&nbsp;{{ 'campaign.not_certified' | translate }} ({{ tp.promoClass }})
          </span>
        </div>

      </div>

      <div class="m10" style="margin-left: 30px;">



        <button data-testid="generate_coupon_preview" class="btn"
          [ngClass]="{'btn-disabled': disable.generaCouponPreview == true }" *ngIf="show.generaCouponPreview"
          [disabled]="disable.generaCouponPreview" (click)="onClickGeneraCouponPreview()">
          {{ 'campaign.generate_coupon_preview' | translate }}
        </button>

        <span class="couponGenerati"
          *ngIf="messageInstanceObject && messageInstanceObject.status == 'G' && messageInstanceObject.flgPreview == '1'">
          {{ 'campaign.generated_coupon_preview' | translate }}<span class="pointer"
            (click)="onClickGeneratedCoupon()"><b>{{messageInstanceObject.actualGeneratedCoupon}}</b></span>
        </span>

        <button data-testid="generate_definitive_coupons" class="btn"
          [ngClass]="{'btn-disabled': disable.generaDefinitiviRichiediPubblicazioni == true }"
          *ngIf="show.generaDefinitiviRichiediPubblicazioni" [disabled]="disable.generaDefinitiviRichiediPubblicazioni"
          (click)="onClickGeneraCouponDefinitivi()">
          {{ 'campaign.generate_definitive_coupons' | translate }}
        </button>
        <span class="couponGenerati"
          *ngIf="messageInstanceObject && messageInstanceObject.status == 'P' && messageInstanceObject.flgPreview == '0' && messageInstanceObject.flg_state == '0'">Numero
          coupon definitivi generati: {{messageInstanceObject.actualGeneratedCoupon}}</span>
        <button data-testid="update_promo" class="btn" [ngClass]="{'btn-disabled': disable.aggiornaAzione == true }"
          *ngIf="show.aggiornaAzione" [disabled]="disable.aggiornaAzione" (click)="onClickAggiornaAzione()">
          {{ 'campaign.update_promo' | translate }}
        </button>
        <button data-testid="annullaPubblicazione" class="btn btn-red"
          [ngClass]="{'btn-disabled': disable.annullaPubblicazione == true }" *ngIf="show.annullaPubblicazione"
          [disabled]="disable.annullaPubblicazione" (click)="onClickAnnullaPubblicazione()">
          {{ 'campaign.cancel_publication' | translate }}
        </button>

      </div>

      <br />
      <br />
      <br />

      <div class="m10 certifications descriptionStatus">
        {{ 'campaign.current_status' | translate }}:&nbsp;
        <i class="fa fa-check"
          *ngIf="messageInstanceObject.status == '0' || messageInstanceObject.status == 'G' || messageInstanceObject.status == 'P'"></i>
        <i class="fa fa-spinner"
          *ngIf="messageInstanceObject.status == 'Q' || messageInstanceObject.status == 'S' || messageInstanceObject.status == 'R'"></i>
        <i class="fa fa-times"
          *ngIf="messageInstanceObject.status == 'X' || messageInstanceObject.status == 'U' || messageInstanceObject.status == 'E'"></i>
        <span [ngClass]="{
          'successColor': (messageInstanceObject.status == '0' || messageInstanceObject.status == 'G' || (messageInstanceObject.status == 'P' && messageInstanceObject.flgDpl == '0')),
          'waitColor': (messageInstanceObject.status == 'Q' || messageInstanceObject.status == 'S' || messageInstanceObject.status == 'R') || (messageInstanceObject.status == 'P' && messageInstanceObject.flgDpl == '1'),
          'errorColor': (messageInstanceObject.status == 'X' || messageInstanceObject.status == 'U' || messageInstanceObject.status == 'E')
        }">
          {{statusDescription}}</span>
      </div>


      <div class="m10" style="margin-left: 30px;">
        <!-- bottone blu se mai premuto mentre arancione se già pubblicata -->

        <button data-testid="pubblicaNuovamente" class="standardButton" [ngClass]="{'btn-disabled': disable.pubblicaNuovamente == true ,
                    'orangeColor': ((messageInstanceObject.status == 'P' && messageInstanceObject.flgDpl == '1')
                || messageInstanceObject.status == 'X'),
'btn': ((messageInstanceObject.status == 'P' && messageInstanceObject.flgDpl != '1')
        || messageInstanceObject.status == 'X')

                     }" *ngIf="show.pubblicaNuovamente" [disabled]="disable.pubblicaNuovamente"
          (click)="onClickPubblicaNuovamente()">
          {{ 'campaign.publicate_again' | translate }}
        </button>
      </div>

      <div class="notification-container" *ngIf="publicationRejected">
        <!-- Error message -->
        <div class="error-message">
          <span class="error-text">{{ publicationRejectedMsgError }}</span>
        </div>

        <!-- Retry button -->
        <button class="retry-button" (click)="resetDeploy(messageInstanceObject.id)" *ngIf="generationMethod == couponingMethodMap['D']">
          {{ 'campaign.resetToComplete' | translate}}
        </button>
      </div>

      <div class="noCertifiedWarning"
        *ngIf="certificationInfo.needsCertification && certificationInfo.loaded && !certificationInfo.isCertificated">
        <div>{{ 'campaign.attention_touchpoints' | translate }}</div>
        <div>{{ 'campaign.cannot_proceed' | translate }}</div>
      </div>

      <div class="deployTypeContainer" *ngIf="deployTypesLoaded && messageInstanceObject.status == 'P'">
        <table>
          <thead>
            <tr>
              <th>{{ 'campaign.offer' | translate | uppercase}}</th>
              <th>{{ 'campaign.head' | translate | uppercase}}</th>
              <th>{{ 'campaign.channel' | translate | uppercase}}</th>
              <th>KPROMO</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dt of deployTypeList">
              <td>{{dt.id_promo_off_fk}}</td>
              <td>{{dt.id_promo_head_fk}}</td>
              <td>{{dt.entity_channel_code}} - {{dt.entity_channel_description}}</td>
              <td class="buttonContainer">
                <button (click)="onClickDeployType(dt)" type="button" class="btn btn-primary">{{ 'common.open' |
                  translate}}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<!-- modal per coupon -->

<p-dialog *ngIf="show.modalCoupon" [width]="1500" [height]="800" [(visible)]="show.modalCoupon" [responsive]="true"
  [header]="'Coupon'" showEffect="fade" [modal]="true" class="campaign-dialog">

  <app-campaign-3-view-coupons #viewCoupon data-testid="viewCoupon"
    [messageInstanceId]="messageInstanceObject.id"></app-campaign-3-view-coupons>


</p-dialog>



<!-- modal per ricerca wizard -->

<p-dialog *ngIf="show.modalWizard" [width]="1500" [height]="800" [(visible)]="show.modalWizard" [responsive]="true"
  [header]="'campaign.select_wizard' | translate " showEffect="fade" [modal]="true">

  <app-campaign-3-search-wizard #searchWizard data-testid="searchWizard" (wizardSelected)="onWizardSelected($event)"
    [wizardList]="wizardList"></app-campaign-3-search-wizard>

  <!-- Bottone Annulla -->
  <div class="ui-dialog-footer buttonsContainer">
    <button pButton (click)="onClickAnnulla_ModalWizard()" type="button" class="k-generic-btn footer-btn"
      label="{{'common.cancel' | translate}}"></button>
    <div class="clear_fix"></div>
  </div>

</p-dialog>



<p-dialog header="{{ 'campaign.confirm_delete' | translate }}" [(visible)]="displayDeleteDialog" [modal]="true"
  [closable]="false" class="custom-dialog">

  <div>{{ 'campaign.cancelPublication' | translate }}</div>


  <div class="custom-footer">
    <button type="button" pButton label="{{ 'common.cancel' | translate }}" (click)="closePopupDelete()"
      icon="pi pi-times"></button>
    <button type="button" pButton label="{{ 'common.confirm' | translate }}" (click)="onAnnullaPubblicazione()"
      icon="pi pi-check" style="margin-left: .25em"></button>
  </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-validations/campaign-3-validations.component.html